import React from 'react';
import { FiLogOut } from 'react-icons/fi';

const signOutClickHandler = () => {
    const { REACT_APP_LOGOUT_URL, REACT_APP_CLIENT_ID, REACT_APP_POST_LOGOUT_REDIRECT_URL } = process.env;
    
    sessionStorage.clear();
    localStorage.clear();
    var logoutURL = REACT_APP_LOGOUT_URL + "?client_id=" + REACT_APP_CLIENT_ID + "&post_logout_redirect_uri=" + encodeURIComponent(REACT_APP_POST_LOGOUT_REDIRECT_URL);
    window.location.href = logoutURL;
}

export default function SignOutButton() {
    return (
        <FiLogOut className="sign-out-icon" onClick={signOutClickHandler} />
    );
};